/* eslint-disable no-underscore-dangle */
import { AnalyticsAdapter } from '../types';
import { Analytics } from '../analytics';
import { initializeGTM, removeGTM } from '../gtm';
import { envConfig } from '../../../config';
import { store } from '../../../stores/store';

class GTMAnalytics implements AnalyticsAdapter {
  private _isInitialized = false;

  initialize() {
    removeGTM();

    if (!envConfig.REACT_APP_LOCALE_TO_GTM_DICT) return;

    const gtmContainerId = envConfig.REACT_APP_LOCALE_TO_GTM_DICT.split(',')
      .find(
        (gtmToLocale) =>
          gtmToLocale.split(':').at(0) ===
          store.localizationsStore.selectedCountry?.country_code
      )
      ?.split(':')
      .at(1);

    if (!gtmContainerId) {
      console.warn(
        `No GTM found for locale: ${store.localizationsStore.selectedCountry?.country_code}`
      );
      return;
    }

    initializeGTM(gtmContainerId);
    this._isInitialized = true;
  }

  isInitialized() {
    return this._isInitialized;
  }

  track(event: string, options?: Record<string, string | number>) {
    if (options && options['ecommerce']) {
      window.dataLayer.push({ ecommerce: null });
    }

    const analyticData = { event, ...options };

    window.dataLayer.push(analyticData);
  }
}

export const gtmAnalytics = new Analytics(new GTMAnalytics());
